import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import styles from './mainNavBar.module.scss'
import DesktopNavigation from './DesktopNavigation'
import AccountToggleMobile from './mobile-nav-bar/AccountToggleMobile'
import { NavItem } from './types'
import { getLocalizedPath } from './utils'
import { Player } from 'types/global'

interface NavigationContentProps {
  isScrolled: boolean
  isMobileMenuOpen: boolean
  desktopNavItems: NavItem[]
  activeDropdown: string | null
  toggleDropdown: (name: string) => void
  dropdownRefs: Record<string, React.RefObject<HTMLDivElement>>
  isLoggedIn: boolean
  userProfile: Player | null
  canPostScore: boolean
  hasPendingMatches: boolean
  toggleMobileMenu: () => void
  mobileToggleRef: React.RefObject<HTMLButtonElement>
}

const NavigationContent: React.FC<NavigationContentProps> = ({
  isScrolled,
  isMobileMenuOpen,
  desktopNavItems,
  activeDropdown,
  toggleDropdown,
  dropdownRefs,
  isLoggedIn,
  userProfile,
  canPostScore,
  hasPendingMatches,
  toggleMobileMenu,
  mobileToggleRef,
}) => {
  const { t } = useTranslation(['strCommonUI'])

  return (
    <div className={styles.container}>
      <div className={styles.mainNavInner}>
        <div className={styles.logo}>
          <a
            href={getLocalizedPath('/')}
            title={t('logoTitle', 'World Tennis Number - Powered by ITF')}
          >
            <img
              src='/Content/img/world-tennis-number-logo.svg'
              alt={t('logoAlt', 'World Tennis Number - Powered by ITF')}
            />
          </a>
        </div>

        <div className={styles.navPrimaryContainer}>
          <DesktopNavigation
            dropdownRefs={dropdownRefs}
            navItems={desktopNavItems}
            activeDropdown={activeDropdown}
            toggleDropdown={toggleDropdown}
            isLoggedIn={isLoggedIn}
            userProfile={userProfile}
            canPostScore={canPostScore}
            hasPendingMatches={hasPendingMatches}
          />

          <div className={classNames(styles.mobileToggleContainer, styles.hideOnDesktop)}>
            <AccountToggleMobile
              ref={mobileToggleRef}
              user={userProfile}
              onClick={toggleMobileMenu}
              isMenuOpen={isMobileMenuOpen}
              hasPendingMatches={hasPendingMatches}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default NavigationContent
